module.exports = __webpack_public_path__ + "img/selected7-min.9a457d73.png";